import { getURLPrefix } from "../../../../utils/getUrlPrefix";
import NoImage from "../../../../assets/images/utility/no_image.png";
import type React from "react";
import { useMemo } from "react";

const URL_PREFIX = getURLPrefix();

interface Props {
  id?: string;
  divId?: string;
  style?: React.CSSProperties;
  width?: string | number;
  height?: string | number;
}

function ProductImage(props: Props) {
  const background = useMemo(() => {
    const spec: string[] = [];
    if (props.id) {
      spec.push(`url(${URL_PREFIX}/api/productimage/?product=${props.id}) no-repeat center / contain`);
    }
    spec.push(`url(${NoImage}) no-repeat center / contain`);
    return spec.join(", ");
  }, [props.id]);
  return (
    <div
      id={props.divId !== undefined ? props.divId : "product" + props.id}
      style={{
        userSelect: "none",
        WebkitUserSelect: "none",
        width: props.width ?? "75px",
        height: props.height ?? "75px",

        background,
        ...props.style,
      }}
      draggable="false"
    />
  );
}

interface ProductImageURLProps {
  url: string | null;
  width: string | number;
  height: string | number;
  style?: React.CSSProperties;
}

export const ProductImageURL = ({ url, width, height, style }: ProductImageURLProps) => {
  return (
    <div
      style={{
        userSelect: "none",
        WebkitUserSelect: "none",
        width: width,
        height: height,
        flexShrink: 0,
        minWidth: width,
        background: `url(${url}) no-repeat center / contain, url(${NoImage}) no-repeat center / contain`,
        ...style,
      }}
      draggable="false"
    />
  );
};

export default ProductImage;
